import React, { Component } from 'react';
import { Form, Select, Spin, Tooltip } from 'antd';
import debounce from 'lodash/debounce';
import uniqBy from 'lodash/uniqBy';
import PropTypes from 'prop-types';
import { AddFormItemLabel, AddSelector } from 'utils';
const Option = Select.Option;
const FormItem = Form.Item;
export default class CitiesSelectV2 extends Component {
  constructor(props) {
    super(props);
    this.lastFetchId = 0;
    this.fetchCities = debounce(this.fetchCities, 800);
  }
  static propTypes = {
    countryValue: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
  };
  state = {
    link: '',
    data: [],
    fetching: false,
    value: [],
    inputValue: '',
  };

  componentDidUpdate(prevProps) {
    if (prevProps.countryValue !== this.props.countryValue) {
      const { inputValue } = this.state;
      if (inputValue) {
        this.fetchCities(inputValue);
      } else {
        this.setState({ data: [] });
      }
    }
  }

  fetchCities = (value) => {
    this.lastFetchId += 1;
    const fetchId = this.lastFetchId;
    this.setState({ data: [], fetching: true, inputValue: value });
    fetch(
      `https://wft-geo-db.p.rapidapi.com/v1/geo/cities?languageCode=DE&limit=10&includeDeleted=NONE&countryIds=${this.props.countryValue}&namePrefix=${value}`,
      {
        method: 'GET',
        headers: {
          'x-rapidapi-key':
            '4febbc1e2fmsh385c68cc8d777bdp191a31jsn35df7f7e0d4f',
          'x-rapidapi-host': 'wft-geo-db.p.rapidapi.com',
        },
      }
    ).then((cities) => {
      if (fetchId !== this.lastFetchId) {
        // for fetch callback order
        return;
      }
      const data = cities.data.map((city) => ({
        text: `${city.name}`,
        value: city.name,
      }));

      this.setState({ data: uniqBy(data, 'value'), fetching: false });
    });
  };

  handleChange = (value) => {
    this.setState({
      value,
      data: [],
      fetching: false,
    });
  };

  render() {
    const { fetching, data, value } = this.state;
    const { disabled } = this.props;
    return (
      <>
        {disabled ? (
          <Tooltip>
            <FormItem
              name="city"
              label={<AddFormItemLabel>Deine Stadt</AddFormItemLabel>}
              required={false}
              rules={[
                {
                  required: true,
                  message: 'Bitte gib dein Deine Stadt ein.',
                },
              ]}
              extra="Der Ort, von wo aus das Projekt organisiert wird."
            >
              <AddSelector
                showSearch
                value={value}
                placeholder="Stadt eingeben"
                notFoundContent={
                  fetching ? (
                    <Spin size="small" />
                  ) : (
                    <p>Es gibt kein Ergebnis</p>
                  )
                }
                filterOption={false}
                onSearch={this.fetchCities}
                onKeyUp={this.handleChange}
                style={{ width: '100%' }}
                disabled={true}
              >
                {data.map((d) => (
                  <Option key={d.value}>{d.text}</Option>
                ))}
              </AddSelector>
            </FormItem>
          </Tooltip>
        ) : (
          <FormItem
            name="city"
            label={<AddFormItemLabel>Deine Stadt</AddFormItemLabel>}
            required={false}
            rules={[
              {
                required: true,
                message: 'Bitte gib dein Deine Stadt ein.',
              },
            ]}
            extra="Der Ort, von wo aus das Projekt organisiert wird."
          >
            <AddSelector
              showSearch
              value={value}
              placeholder="Stadt eingeben"
              notFoundContent={
                fetching ? <Spin size="small" /> : <p>Es gibt kein Ergebnis</p>
              }
              filterOption={false}
              onSearch={this.fetchCities}
              onKeyUp={this.handleChange}
              style={{ width: '100%' }}
            >
              {data.map((d) => (
                <Option key={d.value}>{d.text}</Option>
              ))}
            </AddSelector>
          </FormItem>
        )}
      </>
    );
  }
}
